import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../../firebase";
import HelperForMetaData from "../../../Helpers/HelperForMetaData";

const UpdateExpense = async (FormData, ExpenseID) => {
  console.log(FormData, ExpenseID);
  try {
    const ExpenseDocument = doc(db, "Expenses", ExpenseID);

    const data = {
      ...FormData,
      ...HelperForMetaData({}),
    };

    delete data.createdAt;
    delete data.createdBy;

    await updateDoc(ExpenseDocument, data);

    return true;
  } catch (error) {
    console.log("Error Updating expense", error);

    return false;
  }
};

export default UpdateExpense;
